/**
 * Change menu background color when scrolling past header
 */ 

window.addEventListener("scroll", function() {
    var elementTarget = document.getElementById("content");
    if (window.scrollY > elementTarget.offsetTop) {

        // Add scrolling class after scrolling past header
        document.querySelector('.page-header').classList.add('scrolling');
        document.querySelector('.navbar .main-navigation').classList.add('scrolling');

        // Switch logo when scrolling past header
        document.querySelector('.page-header .white').classList.add('hidden');
        document.querySelector('.page-header .black').classList.remove('hidden');

    } else {

        // Remove scrolling class when scrolling to header
        document.querySelector('.page-header').classList.remove('scrolling');
        document.querySelector('.navbar .main-navigation').classList.remove('scrolling');

        // Switch logo when scrolling past header
        document.querySelector('.page-header .black').classList.add('hidden');
        document.querySelector('.page-header .white').classList.remove('hidden');

    }
});